class VwGnlOrganizasyonEntegreDTO {
    id: number = 0;
    organizasyonId?: number = null;
    entegretipId?: number = null;
    kodu?: string = "";
    sifre?: string = "";
    url?: string = "";
    uygulamakodu?: string = "";
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    organizasyonAdi?: string = "";
};
export default VwGnlOrganizasyonEntegreDTO;